import Vue from "vue";

import VueCookie from 'vue-cookie';
import VueFlashMessage from 'vue-flash-message';
// import VueYandexMetrika from 'vue-yandex-metrika'

import App from "./App.vue";
import router from "./router";
import store from "./store";
import { http } from '@/utils/http';
import GoToMethods from '@/plugins/GoToMethods';

Vue.use(VueCookie);
Vue.use(VueFlashMessage);
Vue.use(GoToMethods);

Vue.config.productionTip = false;
Vue.prototype.$http = http;

// console.log("NODE_ENV", process.env.NODE_ENV)
// Vue.use(VueYandexMetrika, {
//     id: 56122855,
//     router: router,
//     env: process.env.NODE_ENV
// });

new Vue({
  router,
  store,
  render: h => h(App),
  beforeCreate: async function() {
    const existingAuthHeaders = this.$cookie.get('authHeaders')

    if (existingAuthHeaders && existingAuthHeaders.length) { // A string at this point
      const authHeaders = JSON.parse(existingAuthHeaders)
      this.$store.commit('auth', authHeaders)

      console.log('this.$http', this.$http);
      this.$store.dispatch('loadCurrentUser');
    }
  },
  created: async function() {
    this.$store.dispatch('loadTags');
  }
}).$mount("#app");
